// Inert blob anchors for opt-in verified publishing. Not part of COLLECTION (the three
// loadable site/deployment/manifest types) and never a handler target or route collection.
export const BLOB_STAGING_COLLECTION = "app.szzt.staging";
